"use client";

import { SearchQuery, SProduct } from "@/__generated__/graphql";
import { Grid } from "@mui/material";
import ProductCard from "./ProductCard";
import NotFoundComponent from "@/app/(main)/_components/NotFoundComponent";
import { DiscoverySurface } from "@/lib/productDiscovery/trackProductDiscovery";

type Props = {
  items?: SearchQuery["search"]["items"];
  surface?: DiscoverySurface;
};

export default function ProductsList({ items, surface }: Props) {
  return (
    <Grid container spacing={2} item xs={12}>
      {items && items.length <= 0 && <NotFoundComponent primary={"محصولی یافت نشد!"} secondary={""} image={"/errors/noProducts.svg"} />}
      {items &&
        items.map((product, i) => {
          return (
            <Grid key={String(product.id) + String(i)} item xs={6} md={4} sm={4} lg={3} xl={3}>
              <ProductCard product={product as SProduct} surface={surface} position={i} />
            </Grid>
          );
        })}
    </Grid>
  );
}
